module.exports = __webpack_public_path__ + "img/reef.a6b23bd3.jpeg";